<template>
    <div class="new-project__tabs-inner" @click="changeMenuTabs">
        <button class="tab" :class="{'active': activeTabVal == 'styleQuiz'}" id="styleQuiz">{{$t('project_details.tab_menu.style_quiz')}}</button>
        <button class="tab" :class="{'active': activeTabVal == 'proposal'}" id="proposal">{{$t('project_details.tab_menu.ewoods_proposal')}}</button>
        <button class="tab" :class="{'active': activeTabVal == 'shoppingList'}" id="shoppingList">{{$t('project_details.tab_menu.shopping_list')}}</button>
        <button class="tab" :class="{'active': activeTabVal == 'order'}" id="order">{{$t('project_details.tab_menu.orders')}}</button>
<!--        <button class="tab" :class="{'active': activeTabVal == 'favorites'}" id="favorites">{{$t('project_details.tab_menu.favorites')}}</button>-->
<!--        <button class="tab" :class="{'active': activeTabVal == 'visualization'}" id="visualization">{{$t('project_details.tab_menu.visualization')}}</button>-->
<!--        <button class="tab" :class="{'active': activeTabVal == 'planner'}" id="planner">{{$t('project_details.tab_menu.2d_planner')}}</button>-->
    </div>
</template>

<script>
import {ref, watch} from "vue";

export default {
    name: "TabsMenu",
    props: {
        activeTab: {
            default: 'proposal',
            type: String
        }
    },
    setup(props,{emit}) {
        let activeTabVal = ref(props.activeTab)

        watch(() => props.activeTab, (first, second) => {
            activeTabVal.value = first;
        });

        function changeMenuTabs(e) {
            activeTabVal.value = e.target.id;
            emit('changeTab',e.target.id);
        }

        return {
            activeTabVal,
            changeMenuTabs
        }
    }
}
</script>

<style scoped>

</style>